export const cloudflare_workers_aiModels = {
    id: "cloudflare-workers-ai",
    name: "Cloudflare Workers AI",
    npm: "workers-ai-provider",
    doc: "https://developers.cloudflare.com/workers-ai/models/",
    env: ["CLOUDFLARE_ACCOUNT_ID", "CLOUDFLARE_API_KEY"],
    models: {
        "starling-lm-7b-beta": {
            id: "starling-lm-7b-beta",
            name: "@hf/nexusflow/starling-lm-7b-beta",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-03-19",
            last_updated: "2024-04-03",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "deepseek-coder-6.7b-base-awq": {
            id: "deepseek-coder-6.7b-base-awq",
            name: "@hf/thebloke/deepseek-coder-6.7b-base-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-11-05",
            last_updated: "2023-11-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "openchat-3.5-0106": {
            id: "openchat-3.5-0106",
            name: "@cf/openchat/openchat-3.5-0106",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-01-07",
            last_updated: "2024-05-18",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "mistral-7b-instruct-v0.2-lora": {
            id: "mistral-7b-instruct-v0.2-lora",
            name: "@cf/mistral/mistral-7b-instruct-v0.2-lora",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-04-01",
            last_updated: "2024-04-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 15000,
                output: 15000,
            },
        },
        "llama-3.1-8b-instruct-awq": {
            id: "llama-3.1-8b-instruct-awq",
            name: "@cf/meta/llama-3.1-8b-instruct-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-07-25",
            last_updated: "2024-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.12,
                output: 0.27,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "mistral-7b-instruct-v0.2": {
            id: "mistral-7b-instruct-v0.2",
            name: "@hf/mistral/mistral-7b-instruct-v0.2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-12-11",
            last_updated: "2025-07-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 3072,
                output: 3072,
            },
        },
        "llava-1.5-7b-hf": {
            id: "llava-1.5-7b-hf",
            name: "@cf/llava-hf/llava-1.5-7b-hf",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: false,
            release_date: "2023-12-05",
            last_updated: "2025-06-06",
            modalities: {
                input: ["image", "text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "resnet-50": {
            id: "resnet-50",
            name: "@cf/microsoft/resnet-50",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2022-03-16",
            last_updated: "2024-02-13",
            modalities: {
                input: ["image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.0000025,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "deepseek-coder-6.7b-instruct-awq": {
            id: "deepseek-coder-6.7b-instruct-awq",
            name: "@hf/thebloke/deepseek-coder-6.7b-instruct-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-11-05",
            last_updated: "2023-11-13",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "llama-3.1-70b-instruct": {
            id: "llama-3.1-70b-instruct",
            name: "@cf/meta/llama-3.1-70b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-07-16",
            last_updated: "2024-12-15",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            limit: {
                context: 24000,
                output: 24000,
            },
        },
        "qwen1.5-0.5b-chat": {
            id: "qwen1.5-0.5b-chat",
            name: "@cf/qwen/qwen1.5-0.5b-chat",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-01-31",
            last_updated: "2024-04-30",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32000,
                output: 32000,
            },
        },
        "qwen1.5-14b-chat-awq": {
            id: "qwen1.5-14b-chat-awq",
            name: "@cf/qwen/qwen1.5-14b-chat-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-02-03",
            last_updated: "2024-04-30",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 7500,
                output: 7500,
            },
        },
        "llama-3.2-3b-instruct": {
            id: "llama-3.2-3b-instruct",
            name: "@cf/meta/llama-3.2-3b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-09-18",
            last_updated: "2024-10-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.051,
                output: 0.34,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "gemma-7b-it-lora": {
            id: "gemma-7b-it-lora",
            name: "@cf/google/gemma-7b-it-lora",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-04-02",
            last_updated: "2024-04-02",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 3500,
                output: 3500,
            },
        },
        "gemma-3-12b-it": {
            id: "gemma-3-12b-it",
            name: "@cf/google/gemma-3-12b-it",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-03-01",
            last_updated: "2025-03-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.35,
                output: 0.56,
            },
            limit: {
                context: 80000,
                output: 80000,
            },
        },
        "llama-3-8b-instruct": {
            id: "llama-3-8b-instruct",
            name: "@cf/meta/llama-3-8b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-04-17",
            last_updated: "2025-06-19",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.28,
                output: 0.83,
            },
            limit: {
                context: 7968,
                output: 7968,
            },
        },
        "gemma-7b-it": {
            id: "gemma-7b-it",
            name: "@hf/google/gemma-7b-it",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-02-13",
            last_updated: "2024-08-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "qwq-32b": {
            id: "qwq-32b",
            name: "@cf/qwen/qwq-32b",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-03-05",
            last_updated: "2025-03-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.66,
                output: 1,
            },
            limit: {
                context: 24000,
                output: 24000,
            },
        },
        "llama-3.2-1b-instruct": {
            id: "llama-3.2-1b-instruct",
            name: "@cf/meta/llama-3.2-1b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-09-18",
            last_updated: "2024-10-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.027,
                output: 0.2,
            },
            limit: {
                context: 60000,
                output: 60000,
            },
        },
        "falcon-7b-instruct": {
            id: "falcon-7b-instruct",
            name: "@cf/tiiuae/falcon-7b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-04-25",
            last_updated: "2024-10-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "llama-3.1-8b-instruct-fast": {
            id: "llama-3.1-8b-instruct-fast",
            name: "@cf/meta/llama-3.1-8b-instruct-fast",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-07-18",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "tinyllama-1.1b-chat-v1.0": {
            id: "tinyllama-1.1b-chat-v1.0",
            name: "@cf/tinyllama/tinyllama-1.1b-chat-v1.0",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-12-30",
            last_updated: "2024-03-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 2048,
                output: 2048,
            },
        },
        "phoenix-1.0": {
            id: "phoenix-1.0",
            name: "@cf/leonardo/phoenix-1.0",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2025-08-25",
            last_updated: "2025-08-25",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: false,
            cost: {
                input: 0.0058,
                output: 0.0058,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "stable-diffusion-v1-5-inpainting": {
            id: "stable-diffusion-v1-5-inpainting",
            name: "@cf/runwayml/stable-diffusion-v1-5-inpainting",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-02-27",
            last_updated: "2024-02-27",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "llama-3-8b-instruct-awq": {
            id: "llama-3-8b-instruct-awq",
            name: "@cf/meta/llama-3-8b-instruct-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-05-09",
            last_updated: "2024-05-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.12,
                output: 0.27,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "openhermes-2.5-mistral-7b-awq": {
            id: "openhermes-2.5-mistral-7b-awq",
            name: "@hf/thebloke/openhermes-2.5-mistral-7b-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-11-02",
            last_updated: "2023-11-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "llama-2-7b-chat-hf-lora": {
            id: "llama-2-7b-chat-hf-lora",
            name: "@cf/meta-llama/llama-2-7b-chat-hf-lora",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-07-13",
            last_updated: "2024-04-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "gpt-oss-20b": {
            id: "gpt-oss-20b",
            name: "@cf/openai/gpt-oss-20b",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2025-08-04",
            last_updated: "2025-08-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.3,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "llama-3.1-8b-instruct-fp8": {
            id: "llama-3.1-8b-instruct-fp8",
            name: "@cf/meta/llama-3.1-8b-instruct-fp8",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-07-25",
            last_updated: "2024-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.29,
            },
            limit: {
                context: 32000,
                output: 32000,
            },
        },
        whisper: {
            id: "whisper",
            name: "@cf/openai/whisper",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2023-11-07",
            last_updated: "2024-08-12",
            modalities: {
                input: ["audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.00045,
                output: 0.00045,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "uform-gen2-qwen-500m": {
            id: "uform-gen2-qwen-500m",
            name: "@cf/unum/uform-gen2-qwen-500m",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-02-15",
            last_updated: "2024-04-24",
            modalities: {
                input: ["image", "text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "bart-large-cnn": {
            id: "bart-large-cnn",
            name: "@cf/facebook/bart-large-cnn",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2022-03-02",
            last_updated: "2024-02-13",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "mistral-7b-instruct-v0.1": {
            id: "mistral-7b-instruct-v0.1",
            name: "@cf/mistral/mistral-7b-instruct-v0.1",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-09-27",
            last_updated: "2025-07-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.11,
                output: 0.19,
            },
            limit: {
                context: 2824,
                output: 2824,
            },
        },
        "una-cybertron-7b-v2-bf16": {
            id: "una-cybertron-7b-v2-bf16",
            name: "@cf/fblgit/una-cybertron-7b-v2-bf16",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-12-02",
            last_updated: "2024-03-08",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 15000,
                output: 15000,
            },
        },
        "hermes-2-pro-mistral-7b": {
            id: "hermes-2-pro-mistral-7b",
            name: "@hf/nousresearch/hermes-2-pro-mistral-7b",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-03-11",
            last_updated: "2024-09-08",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 24000,
                output: 24000,
            },
        },
        "llama-2-13b-chat-awq": {
            id: "llama-2-13b-chat-awq",
            name: "@hf/thebloke/llama-2-13b-chat-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-09-19",
            last_updated: "2023-11-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "qwen2.5-coder-32b-instruct": {
            id: "qwen2.5-coder-32b-instruct",
            name: "@cf/qwen/qwen2.5-coder-32b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-11-06",
            last_updated: "2025-01-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.66,
                output: 1,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "m2m100-1.2b": {
            id: "m2m100-1.2b",
            name: "@cf/meta/m2m100-1.2b",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2022-03-02",
            last_updated: "2023-11-16",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.34,
                output: 0.34,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        melotts: {
            id: "melotts",
            name: "@cf/myshell-ai/melotts",
            attachment: true,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-07-19",
            last_updated: "2024-07-19",
            modalities: {
                input: ["text"],
                output: ["audio"],
            },
            open_weights: true,
            cost: {
                input: 0.0002,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "stable-diffusion-xl-base-1.0": {
            id: "stable-diffusion-xl-base-1.0",
            name: "@cf/stabilityai/stable-diffusion-xl-base-1.0",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2023-07-25",
            last_updated: "2023-10-30",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "lucid-origin": {
            id: "lucid-origin",
            name: "@cf/leonardo/lucid-origin",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2025-08-25",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: false,
            cost: {
                input: 0.007,
                output: 0.007,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "llama-3.1-8b-instruct": {
            id: "llama-3.1-8b-instruct",
            name: "@cf/meta/llama-3.1-8b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-07-18",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.28,
                output: 0.83,
            },
            limit: {
                context: 7968,
                output: 7968,
            },
        },
        "qwen1.5-7b-chat-awq": {
            id: "qwen1.5-7b-chat-awq",
            name: "@cf/qwen/qwen1.5-7b-chat-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-02-03",
            last_updated: "2024-04-30",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 20000,
                output: 20000,
            },
        },
        "mistral-small-3.1-24b-instruct": {
            id: "mistral-small-3.1-24b-instruct",
            name: "@cf/mistralai/mistral-small-3.1-24b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-03-11",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.35,
                output: 0.56,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "llama-3.2-11b-vision-instruct": {
            id: "llama-3.2-11b-vision-instruct",
            name: "@cf/meta/llama-3.2-11b-vision-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-09-18",
            last_updated: "2024-12-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.049,
                output: 0.68,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "llama-3.3-70b-instruct-fp8-fast": {
            id: "llama-3.3-70b-instruct-fp8-fast",
            name: "@cf/meta/llama-3.3-70b-instruct-fp8-fast",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.29,
                output: 2.25,
            },
            limit: {
                context: 24000,
                output: 24000,
            },
        },
        "phi-2": {
            id: "phi-2",
            name: "@cf/microsoft/phi-2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-12-13",
            last_updated: "2024-04-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 2048,
                output: 2048,
            },
        },
        "whisper-large-v3-turbo": {
            id: "whisper-large-v3-turbo",
            name: "@cf/openai/whisper-large-v3-turbo",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-10-01",
            last_updated: "2024-10-04",
            modalities: {
                input: ["audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.00051,
                output: 0.00051,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "mistral-7b-instruct-v0.1-awq": {
            id: "mistral-7b-instruct-v0.1-awq",
            name: "@hf/thebloke/mistral-7b-instruct-v0.1-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-09-27",
            last_updated: "2023-11-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "aura-1": {
            id: "aura-1",
            name: "@cf/deepgram/aura-1",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2025-08-27",
            last_updated: "2025-07-07",
            modalities: {
                input: ["text"],
                output: ["audio"],
            },
            open_weights: true,
            cost: {
                input: 0.015,
                output: 0.015,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "neural-chat-7b-v3-1-awq": {
            id: "neural-chat-7b-v3-1-awq",
            name: "@hf/thebloke/neural-chat-7b-v3-1-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-11-15",
            last_updated: "2023-11-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "gpt-oss-120b": {
            id: "gpt-oss-120b",
            name: "@cf/openai/gpt-oss-120b",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2025-08-04",
            last_updated: "2025-08-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.35,
                output: 0.75,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "qwen1.5-1.8b-chat": {
            id: "qwen1.5-1.8b-chat",
            name: "@cf/qwen/qwen1.5-1.8b-chat",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-01-30",
            last_updated: "2024-04-30",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32000,
                output: 32000,
            },
        },
        "nova-3": {
            id: "nova-3",
            name: "@cf/deepgram/nova-3",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2025-06-05",
            last_updated: "2025-07-08",
            modalities: {
                input: ["audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.0052,
                output: 0.0052,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "llama-4-scout-17b-16e-instruct": {
            id: "llama-4-scout-17b-16e-instruct",
            name: "@cf/meta/llama-4-scout-17b-16e-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-04-02",
            last_updated: "2025-05-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.27,
                output: 0.85,
            },
            limit: {
                context: 131000,
                output: 131000,
            },
        },
        "gemma-2b-it-lora": {
            id: "gemma-2b-it-lora",
            name: "@cf/google/gemma-2b-it-lora",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-04-02",
            last_updated: "2024-04-02",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "sqlcoder-7b-2": {
            id: "sqlcoder-7b-2",
            name: "@cf/defog/sqlcoder-7b-2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-02-05",
            last_updated: "2024-02-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 10000,
                output: 10000,
            },
        },
        "deepseek-math-7b-instruct": {
            id: "deepseek-math-7b-instruct",
            name: "@cf/deepseek-ai/deepseek-math-7b-instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-02-05",
            last_updated: "2024-02-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "llama-2-7b-chat-fp16": {
            id: "llama-2-7b-chat-fp16",
            name: "@cf/meta/llama-2-7b-chat-fp16",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-07-26",
            last_updated: "2023-07-26",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.56,
                output: 6.67,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "deepseek-r1-distill-qwen-32b": {
            id: "deepseek-r1-distill-qwen-32b",
            name: "@cf/deepseek-ai/deepseek-r1-distill-qwen-32b",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-01-20",
            last_updated: "2025-02-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 4.88,
            },
            limit: {
                context: 80000,
                output: 80000,
            },
        },
        "discolm-german-7b-v1-awq": {
            id: "discolm-german-7b-v1-awq",
            name: "@cf/thebloke/discolm-german-7b-v1-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-01-18",
            last_updated: "2024-01-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "stable-diffusion-xl-lightning": {
            id: "stable-diffusion-xl-lightning",
            name: "@cf/bytedance/stable-diffusion-xl-lightning",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-02-20",
            last_updated: "2024-04-03",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "whisper-tiny-en": {
            id: "whisper-tiny-en",
            name: "@cf/openai/whisper-tiny-en",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2022-09-26",
            last_updated: "2024-01-22",
            modalities: {
                input: ["audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "zephyr-7b-beta-awq": {
            id: "zephyr-7b-beta-awq",
            name: "@hf/thebloke/zephyr-7b-beta-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-10-27",
            last_updated: "2023-11-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "flux-1-schnell": {
            id: "flux-1-schnell",
            name: "@cf/black-forest-labs/flux-1-schnell",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-07-31",
            last_updated: "2024-08-16",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: true,
            cost: {
                input: 0.000053,
                output: 0.00011,
            },
            limit: {
                context: 2048,
                output: 0,
            },
        },
        "stable-diffusion-v1-5-img2img": {
            id: "stable-diffusion-v1-5-img2img",
            name: "@cf/runwayml/stable-diffusion-v1-5-img2img",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-02-27",
            last_updated: "2024-02-27",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "llama-2-7b-chat-int8": {
            id: "llama-2-7b-chat-int8",
            name: "@cf/meta/llama-2-7b-chat-int8",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-09-25",
            last_updated: "2023-09-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "llamaguard-7b-awq": {
            id: "llamaguard-7b-awq",
            name: "@hf/thebloke/llamaguard-7b-awq",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2023-12-11",
            last_updated: "2023-12-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "llama-guard-3-8b": {
            id: "llama-guard-3-8b",
            name: "@cf/meta/llama-guard-3-8b",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            release_date: "2024-07-22",
            last_updated: "2024-10-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.48,
                output: 0.03,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
        "dreamshaper-8-lcm": {
            id: "dreamshaper-8-lcm",
            name: "@cf/lykon/dreamshaper-8-lcm",
            attachment: true,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2023-12-06",
            last_updated: "2023-12-07",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 0,
            },
        },
    },
};
export default cloudflare_workers_aiModels;
//# sourceMappingURL=cloudflare-workers-ai.js.map